import { generateHexId } from 'ui-components/src/utilities';

const MAX_FILE_SIZE_MB = 10;

type Action =
  | { type: 'ADD_FILES'; files: File[] }
  | { type: 'SET_FILE_NAME'; id: string; name: string }
  | { type: 'REMOVE_FILE'; id: string }
  | { type: 'READY'; id: string }
  | { type: 'UPLOADING'; id: string }
  | { type: 'UPLOAD_FAILURE'; id: string }
  | { type: 'UPLOAD_SUCCESS'; id: string };

export function uploadStateReducer(
  state: FileState[],
  action: Action,
): FileState[] {
  const newState = [...state];

  switch (action.type) {
    case 'ADD_FILES':
      return [...newState, ...action.files.map(toFileState)];
    case 'SET_FILE_NAME':
      return updateFileName(newState, action.id, action.name);
    case 'REMOVE_FILE':
      return newState.filter((state) => state.id !== action.id);
    default:
      return updateUploadStatus(newState, action.id, action.type);
  }
}

function updateFileName(
  state: FileState[],
  id: string,
  newName: string,
): FileState[] {
  const index = state.findIndex((item) => item.id === id);
  state[index] = { ...state[index], name: newName };
  return state;
}

function updateUploadStatus(
  state: FileState[],
  id: string,
  status: UploadStatus,
) {
  const index = state.findIndex((item) => item.id === id);
  state[index] = { ...state[index], status };
  return state;
}

export interface FileState {
  id: string;
  name: string;
  file: File;
  status: UploadStatus;
}

export type UploadStatus =
  | 'READY'
  | 'INVALID_SIZE'
  | 'UPLOADING'
  | 'UPLOAD_FAILURE'
  | 'UPLOAD_SUCCESS';

export function toFileState(file: File): FileState {
  const hasValidSize = file.size * Math.pow(10, -6) < MAX_FILE_SIZE_MB;
  return {
    id: generateHexId(10),
    name: file.name,
    file,
    status: hasValidSize ? 'READY' : 'INVALID_SIZE',
  };
}
